import hookSiteSelectedFactory from "@/stores/base-factories/store-site-selection";
import createStore from "@Stores/base-factories";

import { hookGlobalCustomFieldsFactory } from "./customFields";
import { hookGlobalSiteSettingFactory } from "./factory";
import { hookGlobalAppVersionFactory } from "./version";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extend(hookGlobalSiteSettingFactory('cms/setting'))
  .extend(hookGlobalAppVersionFactory())
  .extend(hookGlobalCustomFieldsFactory())
  .factory()

export {
  Provider as GlobalProvider,
  useStore as useGlobalStore,
}
